import type { Building } from "building-types/building/buildingTypes";
import type { BaseTrimMolding } from "building-types/molding/trimMoldingTypes";
import type { BuildingGenerationIssue } from "building-types/settings/buildingGenerationIssue";
import type { ActiveProfileSource } from "building-types/settings/profileCatalogSettings";
import type { RWTable, Table } from "common/data/table";
import { makeBaseTrimMolding } from "../generationTools/generateBaseTrimMoldingTools";
import memo from "../utils/memo";

function select({
  levels,
  wallMasses,
  rooms,
  roomFloorAssemblies,
  walls,
  planarGraphs,
  settings,
  trimEdgeBehaviors,
  doc,
  enabledFeatures,
}: Pick<
  Building,
  | "levels"
  | "wallMasses"
  | "rooms"
  | "roomFloorAssemblies"
  | "walls"
  | "planarGraphs"
  | "settings"
  | "trimEdgeBehaviors"
  | "doc"
  | "enabledFeatures"
>) {
  return {
    levels,
    wallMasses,
    rooms,
    roomFloorAssemblies,
    walls,
    planarGraphs,
    settings,
    trimEdgeBehaviors,
    profiles: doc.profiles,
    settingsToCatalogs: enabledFeatures.settingsToCatalogs,
  };
}

function generate({
  levels,
  wallMasses,
  rooms,
  walls,
  settings,
  roomFloorAssemblies,
  trimEdgeBehaviors,
  profiles,
  settingsToCatalogs,
}: ReturnType<typeof select>): {
  baseTrimMoldings: Table<BaseTrimMolding>;
  issues: BuildingGenerationIssue[];
} {
  const baseTrimMoldings: RWTable<BaseTrimMolding> = {};
  const issues: BuildingGenerationIssue[] = [];

  const { interiorTrim, profile } = settings;
  const profileSource: ActiveProfileSource = { settingsToCatalogs, profiles, profileSettings: profile };

  for (const i in levels) {
    makeBaseTrimMolding({
      level: levels[i],
      wallMasses,
      rooms,
      roomFloorAssemblies,
      walls,
      profileSource,
      interiorTrim,
      trimEdgeBehaviors,
      baseTrimMoldings,
      issues,
    });
  }

  return { baseTrimMoldings, issues };
}

export default memo(select, generate);
